import React from 'react';
import { Link } from 'react-router-dom';
import { SwatchBook } from 'lucide-react';

const Navbar = ({ sourcePage }) => {
  return (
    <nav className="flex items-center justify-between p-6 border-b">
      <div className="text-2xl font-bold text-black">
        {/* Logo with proper router Link */}
        <Link to="/" className="flex items-center">
          <SwatchBook className="w-8 h-8 mr-2 text-orange-500" />
          <span className="hidden sm:inline">dessino.ai</span>
        </Link>
      </div>

      <div>
        {sourcePage === 'projects' ? (
          <span className="mr-6 text-black font-semibold cursor-default">
            projects
          </span>
        ) : (
          <Link
            to="/projects"
            className="mr-6 text-gray-700 hover:text-black"
          >
            projects
          </Link>
        )}

        {sourcePage === 'account' ? (
          <span className="mr-6 text-black font-semibold cursor-default">
            account
          </span>
        ) : (
          <Link
            to="/account"
            className="mr-6 text-gray-700 hover:text-black"
          >
            account
          </Link>
        )}

        {sourcePage === 'help' ? (
          <span className="text-black font-semibold cursor-default">
            help
          </span>
        ) : (
          <Link
            to="/user/help"
            className="text-gray-700 hover:text-black"
          >
            help
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;